import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "boxicons/css/boxicons.min.css";
import "remixicon/fonts/remixicon.css";
import "./_theme/css/style.css";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./components/auth/Login";
import Dashboard from "./components/dashboard/Dashboard";
import AdminLayout from "./components/layout/AdminLayout";
import NotFound from "./components/layout/NotFound";
import PrivateRoutes from "./routings/PrivateRoutes";
import Clinics from "./components/clinics";
import ClinicInfo from "./components/clinics/pages/ClinicInfo";
import ClinicAdd from "./components/clinics/pages/ClinicAdd";
import Articles from "./components/articles";
import AddArticles from "./components/articles/pages/AddArticles";
import EditArticle from "./components/articles/pages/EditArticle";
import ManageCategory from "./components/articles/pages/ManageCategory";
import EmailDashboard from "./components/template/email/EmailDashboard";
import SmsDashboard from "./components/template/sms/SmsDashboard";
import TelephoneDashboard from "./components/template/telephone/TelephoneDashboard";
import EditEmailTemplate from "./components/template/email/EditEmailTemplate";
import EditSmsTemplate from "./components/template/sms/EditSmsTemplate";
import EditCallTemplate from "./components/template/telephone/EditCallTemplate";
import LoadTemplate from "./components/template/common/LoadTemplate";
import AddEmailTemplate from "./components/template/email/AddEmailTemplate";
import AddSmsTemplate from "./components/template/sms/AddSmsTemplate";
import AddCallTemplate from "./components/template/telephone/AddCallTemplate";
import ClinicEditSmsTemplate from "./components/template/sms/ClinicEditSmsTemplate";
import Campaign from "./components/campaign/Campaign";
import ClinicEditCallTemplate from "./components/template/telephone/ClinicEditCallTemplate";
import ClinicEditEmailTemplate from "./components/template/email/ClinicEditEmailTemplate";
import CampaignPreview from "./components/campaign/CampaignPreview";
import CampaignStats from "./components/campaign/CampaignStats";
import CampaignQueue from "./components/campaign/CampaignQueue";
import CampaignStop from "./components/campaign/CampaignStop";
import SurveyEdit from "./components/survey/SurveyEdit";
import Survey from "./components/survey/Survey";
import StateObject from "./components/helpers/StateObject";
import ProcessPage from "./components/process";
import Recalls from "./components/recalls/Recalls";
import RecallEdit from "./components/recalls/RecallEdit";
import TemplateEmail from "./components/campaign/TemplateEmail";
import TemplateSms from "./components/campaign/TemplateSms";
import Logs from "./components/logs";
import AdminTemplateDashboard from "./components/template/admin/AdminTemplateDashboard";
import CreateAdminEmailTemplate from "./components/template/admin/CreateAdminEmailTemplate";
import CreateAdminSmsTemplate from "./components/template/admin/CreateAdminSmsTemplate";
import CreateAdminCallTemplate from "./components/template/admin/CreateAdminCallTemplate";
import InstallTemplateDashboard from "./components/template/install/InstallTemplateDashboard";
import ClinicTemplateDashboard from "./components/template/clinic/ClinicTemplateDashboard";
import EditAdminSmsTemplate from "./components/template/admin/EditAdminSmsTemplate";
import EditAdminEmailTemplate from "./components/template/admin/EditAdminEmailTemplate";
import EditAdminCallTemplate from "./components/template/admin/EditAdminCallTemplate";
import EditClinicSmsTemplate from "./components/template/clinic/EditClinicSmsTemplate";
import EditClinicCallTemplate from "./components/template/clinic/EditClinicCallTemplate";
import EditClinicEmailTemplate from "./components/template/clinic/EditClinicEmailTemplate";
import AdminSmsGateway from "./components/smsgateway";
import Profile from "./components/profile/Profile";
import SurveyCreate  from "./components/survey/SurveyCreate";
import ClinicSurveyEdit from "./components/survey/ClinicSurveyEdit";
import Notifications from "./components/notifications";
import ThemePreview from "./components/clinics/modules/tabelements/publicthemetab/ThemePreview";
function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/** public routes */}
                <Route path="/" element={<Login/>}/>
                <Route path="login" element={<Login/>}/>
                <Route path="theme-preview/:clinicId" element={<ThemePreview/>}/>

                {/** private routes */}
                <Route element={<AdminLayout/>}>
                    <Route path="dashboard" element={<PrivateRoutes/>}>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                    </Route>
                    <Route path="clinics" element={<PrivateRoutes/>}>
                        <Route index element={<Clinics/>}/>
                        <Route path=":clinicId" element={<ClinicInfo/>}/>
                        <Route path=":clinicId/surveys/:surveyId/edit" element={<ClinicSurveyEdit/>}/>
                        <Route path="new" element={<ClinicAdd/>}/>
                    </Route>
                    <Route path="articles" element={<PrivateRoutes/>}>
                        <Route index element={<Articles/>}/>
                        <Route path=":articleId" element={<EditArticle/>}/>
                        <Route path="new" element={<AddArticles/>}/>
                        <Route path="category" element={<ManageCategory/>}/>
                    </Route>
                    <Route path="campaign" element={<PrivateRoutes/>}>
                        <Route index element={<Campaign/>}/>
                        <Route path="preview">
                            <Route path=":campaignId" element={<CampaignPreview/>}/>
                        </Route>
                        <Route path="stats">
                            <Route path=":campaignId" element={<CampaignStats/>}/>
                        </Route>
                        <Route path="queue">
                            <Route path=":campaignId" element={<CampaignQueue/>}/>
                        </Route>
                        <Route path="stop">
                            <Route path=":campaignId" element={<CampaignStop/>}/>
                        </Route>
                        <Route path="emailtemplate">
                            <Route path=":templateId" element={<TemplateEmail/>}/>
                        </Route>
                        <Route path="smstemplate">
                            <Route path=":templateId" element={<TemplateSms/>}/>
                        </Route>
                    </Route>
                    <Route path="surveys" element={<PrivateRoutes/>}>
                        <Route index element={<Survey/>}/>
                        <Route path="new" element={<SurveyCreate/>}/>
                        <Route path="edit">
                            <Route path=":surveyId" element={<SurveyEdit/>}/>
                        </Route>
                    </Route>
                    <Route path="recalls" element={<PrivateRoutes/>}>
                        <Route index element={<Recalls/>}/>
                        <Route path="edit">
                            <Route path=":recallId" element={<RecallEdit/>}/>
                        </Route>
                    </Route>
                    <Route path="admin-templates" element={<PrivateRoutes/>}>
                        <Route index element={<AdminTemplateDashboard/>}/>
                        <Route path="/admin-templates/email" element={<CreateAdminEmailTemplate/>}/>
                        <Route path="/admin-templates/sms" element={<CreateAdminSmsTemplate/>}/>
                        <Route path="/admin-templates/call" element={<CreateAdminCallTemplate/>}/>
                        <Route path="/admin-templates/edit-sms/:id" element={<EditAdminSmsTemplate/>}/>
                        <Route path="/admin-templates/edit-email/:id" element={<EditAdminEmailTemplate/>}/>
                        <Route path="/admin-templates/edit-call/:id" element={<EditAdminCallTemplate/>}/>
                    </Route>
                    <Route path="install-templates" element={<PrivateRoutes/>}>
                        <Route index element={<InstallTemplateDashboard/>}/>
                    </Route>
                    <Route path="clinic-templates" element={<PrivateRoutes/>}>
                        <Route index element={<ClinicTemplateDashboard/>}/>
                        <Route path="/clinic-templates/:clinicId/edit-sms/:id" element={<EditClinicSmsTemplate/>}/>
                        <Route path="/clinic-templates/:clinicId/edit-call/:id" element={<EditClinicCallTemplate/>}/>
                        <Route path="/clinic-templates/:clinicId/edit-email/:id" element={<EditClinicEmailTemplate/>}/>
                    </Route>

                    <Route path="email-template" element={<PrivateRoutes/>}>
                        <Route index element={<EmailDashboard/>}/>
                        <Route path="add" element={<AddEmailTemplate/>}/>
                        <Route path=":templateId" element={<EditEmailTemplate/>}/>
                        <Route path="edit">
                            <Route path=":clinicId/:templateId" element={<ClinicEditEmailTemplate/>}/>
                        </Route>
                        <Route path="load">
                            <Route path=":clinicId/:type" element={<LoadTemplate/>}/>
                        </Route>
                    </Route>
                    <Route path="sms-template" element={<PrivateRoutes/>}>
                        <Route index element={<SmsDashboard/>}/>
                        <Route path="add" element={<AddSmsTemplate/>}/>
                        <Route path=":templateId" element={<EditSmsTemplate/>}/>
                        <Route path="edit">
                            <Route path=":clinicId/:templateId" element={<ClinicEditSmsTemplate/>}/>
                        </Route>
                        <Route path="load">
                            <Route path=":clinicId/:type" element={<LoadTemplate/>}/>
                        </Route>
                    </Route>
                    <Route path="telephone-template" element={<PrivateRoutes/>}>
                        <Route index element={<TelephoneDashboard/>}/>
                        <Route path="add" element={<AddCallTemplate/>}/>
                        <Route path=":templateId" element={<EditCallTemplate/>}/>
                        <Route path="edit">
                            <Route path=":clinicId/:templateId" element={<ClinicEditCallTemplate/>}/>
                        </Route>
                        <Route path="load">
                            <Route path=":clinicId/:type" element={<LoadTemplate/>}/>
                        </Route>
                    </Route>
                    <Route path="process" element={<PrivateRoutes/>}>
                        <Route index element={<ProcessPage/>}/>
                    </Route>
                    <Route path="logs" element={<PrivateRoutes/>}>
                        <Route path="/logs" element={<Logs/>}/>
                    </Route>

                    <Route path="notifications" element={<PrivateRoutes/>}>
                        <Route index element={<Notifications/>}/>
                    </Route>

                    <Route path="adminsmsgateway" element={<PrivateRoutes/>}>
                        <Route index element={<AdminSmsGateway/>}/> {/* This will match /adminsmsgateway */}
                    </Route>

                    <Route path="currentstate" element={<PrivateRoutes/>}>
                        <Route index element={<StateObject/>}/>
                    </Route>

                    <Route path="profile" element={<PrivateRoutes/>}>
                        <Route path=":userId" element={<Profile/>}/>
                    </Route>

                </Route>

                {/** catch all */}
                <Route path="*" element={<NotFound/>}/>
            </Routes>
            <ToastContainer/>
        </BrowserRouter>
    );
}

export default App;
